import { useContext, createContext, useState, useEffect } from "react";
import { collection, query, getDocs } from "firebase/firestore";
import { db } from "../firebase";

export const ProjectsContext = createContext();
export const useProjects = ()=>{
    return useContext(ProjectsContext)
}

export const ProjectsProvider = ({children}) =>{
    const [state, setState] = useState([])
    const getData = async()=>{
        const base = collection(db, "WorthyProjects");
        const setQuery = query(base);
        const data = await getDocs(setQuery) 
        setState(data.docs)
    }
    
    useEffect(()=>{
        getData()
    }, [])

    return <ProjectsContext.Provider value={state}>
        {children}
    </ProjectsContext.Provider>
}